export default function FSSystemDemoV2() {
  return (
    <section className="py-20 px-8" style={{ background: "#f4f8fb" }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold text-cyan-600 tracking-widest uppercase mb-2 block">System Demo</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">系统演示</h2>
          <p className="text-slate-500 text-sm max-w-2xl mx-auto">实时体验空间数据驱动金融业务增长的核心能力，从空间洞察到业务拓客，全流程可视化呈现</p>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
          <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-1.5">
                <div className="w-3 h-3 rounded-full bg-rose-400"></div>
                <div className="w-3 h-3 rounded-full bg-amber-400"></div>
                <div className="w-3 h-3 rounded-full bg-emerald-400"></div>
              </div>
              <span className="text-slate-500 text-sm font-medium">空天数源金融服务平台 · 系统演示</span>
            </div>
            <a href="https://readdy.cc/preview/12c974b6-d66c-4623-adc0-1f7b380843e2/10602959/dashboard" target="_blank" rel="noopener noreferrer"
              className="text-xs text-cyan-600 hover:text-cyan-700 font-medium flex items-center gap-1 cursor-pointer">
              <i className="ri-external-link-line"></i>新窗口打开
            </a>
          </div>
          <div className="relative" style={{ height: 650 }}>
            <iframe
              src="https://readdy.cc/preview/12c974b6-d66c-4623-adc0-1f7b380843e2/10602959/dashboard"
              title="空天数源金融服务平台系统演示"
              className="w-full h-full border-0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-white to-transparent pointer-events-none"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
